<div class="query-filter">
  <select class="query-filter__property"
          [(ngModel)]="propertyName">
    <option *ngFor="let property of properties"
            [ngValue]="property">{{ property }}</option>
  </select>
  <span class="query-filter__operator">{{ operatorText }}</span>
  <input *ngIf="showInput"
         class="query-filter__value"
         type={{inputType}}
         [(ngModel)]="value">
  <button (click)="deleteFilter()"
          class="lx-btn lx-btn-text cancel-button">
    <i class="lx-icon lx-trash"></i>
  </button>
</div>
